import { render, staticRenderFns } from "./SectionCollapse.vue?vue&type=template&id=63403682"
import script from "./SectionCollapse.vue?vue&type=script&lang=js"
export * from "./SectionCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports